module.exports = __webpack_public_path__ + "img/battle.8329deaf.svg";